<template>
    <div class="login">
    </div>
</template>

<script>
    import Btn from '@/components/Button.vue';

    import { initKeycloak } from '../keycloakService.js';

    export default {

        data() {
            return {
                email_address: "",
                password: "",
                register_url: 'https://www.loxone.com/enen/login/registration/',
                loaderVisible: false,
            }
        },

        methods: {
            login: function() {
                let email_address = this.email_address
                let password = this.password
                this.loaderVisible = true;
                this.$store.dispatch('login', { email_address, password }).catch(err => console.log(err))
            },
            
            handleErrorMessage() {
                if(this.$store.state.loginErrorMessage) {
                    this.loaderVisible = false;
                }

                switch(this.$store.state.loginErrorMessage) {
                    case 'INVALID_PASSWORD':
                        return this.$i18n.t('error.login.invalid_password');
                    case 'UNKNOWN_ERROR':
                        return this.$i18n.t('error.login.unknown_error');
                    case 'MISSING_POST_PARAMS':
                        return this.$i18n.t('error.login.missing_post_params');
                    case 'EMPTY_EMAIL_ADDRESS':
                        return this.$i18n.t('error.login.empty_email_address');
                    case 'EMPTY_PASSWORD':
                        return this.$i18n.t('error.login.empty_password');
                    case 'NO_WEBACCOUNT_FOR_THIS_EMAIL_ADDRESS':
                        return this.$i18n.t('error.login.no_webaccount_exists_for_this_email');
                    case 'WEBACCOUNT_NOT_ACTIVATED':
                        return this.$i18n.t('error.login.webaccount_not_activated');
                    case 'TOO_MANY_LOGIN_ATTEMPTS':
                        return this.$i18n.t('error.login.too_many_login_attempts');
                    case 'Invalid user credentials':
                        return this.$i18n.t('error.login.invalid_password');
                }
            },
            async initializeKeycloak() {
                try {
                    const token = await initKeycloak();
                    if (token) {
                        await this.$store.dispatch('login', { token }).catch(err => console.log(err));
                    } else {
                        console.log('User is not logged in via Keycloak');
                    }
                } catch (error) {
                    console.error('Error initializing Keycloak:', error);
                }
            }
        },

        watch: {
            '$store.state.loginErrorMessage': {
                deep: true,
                handler() {
                    if(this.$store.state.loginErrorMessage != "") {
                        this.handleErrorMessage();
                    }
                }
            }
        },
        async created() {
            await this.initializeKeycloak();
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/utilities/variables';
    @import '../scss/pages/login';

    .login__wrapper--loading{
        text-align: center;

        svg{
            animation: wiggle 2.5s infinite;
        }
    }

    .login__error{
        margin-bottom: 40px;
    }

    @keyframes wiggle {
        0% { transform: rotate(0deg); }
        5% { transform: rotate(5deg); }
        15% { transform: rotate(-5deg); }
        20% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        35% { transform: rotate(-5deg); }
        40% { transform: rotate(0deg); }
        45% { transform: rotate(5deg); }
        55% { transform: rotate(-5deg); }
        70% { transform: rotate(0deg); }
        65% { transform: rotate(5deg); }
        75% { transform: rotate(-5deg); }
        80% { transform: rotate(0deg); }
        85% { transform: rotate(5deg); }
        95% { transform: rotate(-5deg); }
        100% { transform: rotate(0deg); }
    }
</style>